module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-left-6821b28ba8f0d76d3d567e04c049d57a.svg";